import { createContext, useContext } from 'react'

interface OrgAuth {
	token?: string
	authOrgUser?: any
	handleOrganizationChange?: (org: any, orgs: any[]) => Promise<void>
	userOrganizations: any[]
	logOutOrganization?: () => void
	refreshOrgAuth?: (org: { id: string; name: string }) => Promise<void>
}

const OrgAuthContext = createContext<OrgAuth>({ userOrganizations: [] })

const useOrgAuth = (): OrgAuth => {
	return useContext(OrgAuthContext)
}

export { OrgAuthContext, useOrgAuth }
